<template>
  <div class="container wizard">
    <div class="row">
      <div class="col-12 p-0">
        <h2>Resultado de la firma</h2>
      </div>
    </div>
    <div class="row content mt-3">
      <div class="col-12">
        <b-alert v-if="accepted" show variant="success">
          Se ha realizado la firma del contrato de forma exitosa. Se le enviará por correo una copia del mismo.
        </b-alert>
        <b-alert v-else show variant="danger">
          El contrato no fue firmado. Si necesita revisión o asistencia, contáctese con el gestor.
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormColombiaSalud08",
  computed: {
    accepted() {
      return this.$store.state.wizard.accepted;
    },
  },
};
</script>
